<template>
  <div class="app-container">
    <TianDiTuMap 
      ref="tianDiTuMapRef" 
      :center="computedMapCenter" 
      :zoom="computedMapZoom" 
      :companyMarkerImageSrc="companyMarkerImageSrc"
      :tipsText="displayTipsText"
    />
  </div>
</template>

<script>
import TianDiTuMap from './TianDiTuMap.vue'

export default {
  name: 'TianDiTuPage',
  components: {
    TianDiTuMap
  },
  props: {
    // 路由参数传递的属性
    lng: Number,
    lat: Number,
    zoom: Number,
    tipsText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 默认地图中心点坐标
      defaultMapCenter: [104.066541, 30.659462],
      // 默认地图缩放级别
      defaultZoom: 14,
      // 默认提示文字
      defaultTipsText: '',
      // 企业位置标记图片路径
      companyMarkerImageSrc: '/image/kq_position_company.png'
    }
  },
  methods: {
    // 解析mapview参数（从路由查询参数中获取，兼容旧页面）
    parseMapViewParam() {
      const mapview = this.$route.query.mapview;
      if (!mapview) return null;
      
      try {
        // 尝试解析mapview参数（JSON格式）
        const parsed = JSON.parse(mapview);
        return parsed;
      } catch (e) {
        console.warn('mapview参数解析失败:', e);
        return null;
      }
    }
  },
  
  // 监听路由参数变化
  watch: {
    // 监听路由参数变化
    $route: {
      handler() {
        // 路由参数变化时，确保地图组件更新
        this.$nextTick(() => {
          // 地图会通过计算属性自动更新
        });
      },
      immediate: true,
      // 深度监听，确保路由参数变化能被捕获
      deep: true
    }
  },
  
  // 计算属性
  computed: {
    // 判断中心点坐标是否有效
    hasValidCenter() {
      return this.lng !== null && this.lng !== undefined && this.lng !== 0 &&
             this.lat !== null && this.lat !== undefined && this.lat !== 0;
    },
    
    // 地图中心点（优先使用路由参数，然后是mapview解析，最后是默认值）
    computedMapCenter() {
      // 1. 优先使用直接的lng/lat参数
      if (this.hasValidCenter) {
        return [this.lng, this.lat];
      }
      
      // 2. 尝试从mapview参数中获取
      const mapViewData = this.parseMapViewParam();
      if (mapViewData && mapViewData.lng && mapViewData.lat) {
        return [parseFloat(mapViewData.lng), parseFloat(mapViewData.lat)];
      }
      
      // 3. 使用默认值
      return this.defaultMapCenter;
    },
    
    // 地图缩放级别（优先使用路由参数，然后是mapview解析，最后是默认值）
    computedMapZoom() {
      // 1. 优先使用直接的zoom参数
      if (this.zoom !== null && this.zoom !== undefined && !isNaN(this.zoom)) {
        return this.zoom;
      }
      
      // 2. 尝试从mapview参数中获取
      const mapViewData = this.parseMapViewParam();
      if (mapViewData && mapViewData.zoom) {
        return parseInt(mapViewData.zoom);
      }
      
      // 3. 使用默认值
      return this.defaultZoom;
    },
    
    // 提示文字（优先使用路由参数，然后是mapview解析，最后是默认值）
    displayTipsText() {
      // 1. 优先使用直接的tipsText参数
      if (this.$props.tipsText) {
        return this.$props.tipsText;
      }
      
      // 2. 尝试从mapview参数中获取
      const mapViewData = this.parseMapViewParam();
      if (mapViewData && mapViewData.tipsText) {
        return mapViewData.tipsText;
      }
      
      // 3. 使用默认值
      return this.defaultTipsText;
    }
  }
}
</script>

<style>
/* 重置默认样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  width: 100%;
  height: 100%;
}

.app-container {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  position: relative;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  html, body {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

/* 解决iOS Safari底部安全区域问题 */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .app-container {
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>